/*
 * The shapes the resident's medicines page works with, as the server sends them.
 */
import type { Slot } from './schedule-builder.tsx';

export type Medicine = {
  id: string;
  name: string;
  form: string;
  route: string;
  doseText: string;
  doseQty: number | null;
  directions: string;
  times: string[];
  slots: Slot[];
  schedule: string[];
  startsOn: string;
  endsOn: string | null;
  prn: boolean;
  prnReason: string;
  prnMinGap: number | null;
  prnMax24h: number | null;
  controlledDrug: boolean;
  timeCritical: boolean;
  nurseOnly: boolean;
  topical: boolean;
  flags: { insulin?: boolean; warfarin?: boolean; peg?: boolean; patch?: boolean };
  trayType: 'tray' | 'separate' | 'none';
  trayLooks: string;
  notTrayReason: string;
  productId: string | null;
  // The draft waiting against this medicine, if there is one.
  draft?: { id: string; kind: 'change' | 'stop' } | null;
};

export type Draft = Omit<Medicine, 'id' | 'startsOn' | 'draft'> & {
  id: string;
  kind: 'new' | 'change' | 'stop';
  residentId: string;
  residentName: string;
  medicineId: string | null;
  medicineName: string;
  source: string;
  sourceDetail: string;
  startsOn: string | null;
  stopReason: string;
  allergyWarning: string;
  clashWarning: string;
  note: string;
  proposedByName: string;
  proposedAt: string;
  // What it replaces, on the approval list.
  before?: Medicine | null;
};

export type Report = {
  id: string;
  residentId: string;
  residentName: string;
  medicineId: string | null;
  medicineName: string;
  what: 'stopped' | 'dose' | 'times' | 'new' | 'other';
  whatLabel: string;
  detail: string;
  source: string;
  sourceDetail: string;
  reportedBy: string;
  reportedAt: string;
  status: 'open' | 'done';
  doneBy: string;
  doneAt: string | null;
  doneNote: string;
};

export type CycleDates = { number: number; startsOn: string; endsOn: string; nextStartsOn: string };

export const SOURCES: Array<[string, string]> = [
  ['gp', 'GP'],
  ['hospital', 'Hospital discharge'],
  ['clinic', 'Clinic or specialist'],
  ['pharmacy', 'The pharmacy'],
  ['other', 'Somewhere else'],
];
